export const InvoiceType = [
  {
    Id: 1,
    Name: 'INVOICE_TYPE.PAID',
  },
  {
    Id: 2,
    Name: 'INVOICE_TYPE.UNPAID',
  },
]
